import { Component, Input, OnInit } from "@angular/core";
import * as wjGrid from "wijmo/wijmo.grid";
import { findIndex } from "lodash";

interface ColumnInterface {
  index: number;
  value: boolean;
  label: string;
  children: Array<any>;
}

@Component({
  selector: "kl-column-picker",
  templateUrl: "./kl-column-picker.component.html",
  styleUrls: ["./kl-column-picker.component.scss"],
})
export class KlColumnPickerComponent implements OnInit {
  @Input() flexGrid: wjGrid.FlexGrid;
  columns = Array<ColumnInterface>();
  searchText: string;
  haveChild: any;

  constructor() {}

  ngOnInit() {
    this.haveChild = {};
    this.generateColumn();
    this.flexGrid.updatedLayout.addHandler(() => {
      this.generateColumn();
    });
  }

  generateColumn() {
    this.columns = [];
    for (let i = 0; i < this.flexGrid.columns.length; i++) {
      const col = this.flexGrid.columns[i];
      const column = Object.create(null);
      if (col.binding.includes(".")) {
        const splitBinding = col.binding.split(".");
        if (!this.haveChild.hasOwnProperty(splitBinding[0])) {
          this.haveChild[splitBinding[0]] = false;
        }
        const index = findIndex(this.columns, { label: splitBinding[0] });
        if (index === -1) {
          column["label"] = splitBinding[0];
          column["children"] = [
            {
              index: i,
              label: splitBinding[1],
              value: col.visible,
              class: this.haveChild[splitBinding[0]] ? "show-column" : "",
            },
          ];
          this.columns.push(column);
        } else {
          this.columns[index].children.push({
            index: i,
            label: splitBinding[1],
            value: col.visible,
            class: this.haveChild[splitBinding[0]] ? "show-column" : "",
          });
        }
      } else {
        column["index"] = i;
        column["label"] = col.header ? col.header : col.binding;
        column["value"] = col.visible;
        this.columns.push(column);
      }
    }
  }

  checkAll() {
    this.flexGrid.columns.forEach((column) => (column.visible = true));
  }

  unCheckAll() {
    this.flexGrid.columns.forEach((column) => (column.visible = false));
  }

  changePicker(column: ColumnInterface, event) {
    column.value = event.checked;
    const col = this.flexGrid.columns[column.index];
    col.visible = event.checked;
  }

  toggle(column) {
    this.haveChild[column.label] = !this.haveChild[column.label];
    column.children.forEach((child) => {
      document
        .querySelector("p-checkbox." + column.label + "_" + child.label)
        .classList.toggle("show-column");
    });
  }
}
